import { render, staticRenderFns } from "./options-widget.html?vue&type=template&id=28958a2f&scoped=true&"
import script from "./options-widget.js?vue&type=script&lang=js&"
export * from "./options-widget.js?vue&type=script&lang=js&"
import style0 from "./options-widget.scss?vue&type=style&index=0&id=28958a2f&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=28958a2f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28958a2f",
  null
  
)

export default component.exports